export default __webpack_public_path__ + "static/media/ground-ladder-test.5c5a9c22.jpg";